import React from "react";
import { FaTruck, FaTools, FaCheckCircle, FaSearch, FaWrench, FaShoppingBag, FaClipboard, FaPaintBrush } from 'react-icons/fa';
import { LiaCarSolid } from "react-icons/lia";
import { PiThermometerColdLight, PiWrenchLight } from "react-icons/pi";
import { TbReportSearch } from "react-icons/tb";
import { MdRestore, MdOutlineFactCheck, MdOutlineShoppingCart } from "react-icons/md";
import { GiCartwheel, GiElectric } from "react-icons/gi";
import { IoSearchOutline } from "react-icons/io5";
import { LuPaintbrush } from "react-icons/lu";
import { RiToolsLine } from "react-icons/ri";
import { ContentWrapper } from "../../utils/components";
import './services.css';
import AutoFirst from '../../../assets/images/autofirst_1.png';

const ServicesPage = () => {

    const services = [
        {
            title: 'Onderhoud & nazicht',
            description: 'Uitgebreid onderhoud en grondige inspectie van voertuigen om hun prestaties en veiligheid te garanderen.',
            icon: <RiToolsLine className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Carrosserie',
            description: 'Professionele herstellingen en schadeherstel voor carrosserieën, inclusief spuiten en verven van beschadigde delen.',
            icon: <LuPaintbrush className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Verkoop',
            description: 'Betrouwbare tweedehandswagens, nieuwe voertuigen en lichte vrachtauto\'s, zorgvuldig gecontroleerd en verkoopklaar.',
            icon: <MdOutlineShoppingCart className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Autokeuring',
            description: 'Snelle en betrouwbare autokeuringen volgens de wettelijke vereisten voor een veilige en goedgekeurde auto.',
            icon: <MdOutlineFactCheck className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Elektrische herstellingen',
            description: 'Specialistische herstellingen van elektrische systemen in voertuigen, van accuproblemen tot complexere storingen.',
            icon: <GiElectric className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Diagnose',
            description: 'Grondige en snelle diagnostiek van technische problemen in je voertuig om de oorzaak van storingen te achterhalen.',
            icon: <IoSearchOutline className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Mechanische herstellingen',
            description: 'Reparatie en vervanging van motoren, ophangingssystemen, remmen en andere mechanische onderdelen van je voertuig.',
            icon: <PiWrenchLight className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Banden & velgen',
            description: 'Vervangen, balanceren en uitlijnen van banden en velgen voor een veilige en comfortabele rijervaring.',
            icon: <GiCartwheel className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Restauratie',
            description: 'Restauratie van klassieke en vintage voertuigen met zorg en vakmanschap om ze weer in hun oorspronkelijke staat te brengen.',
            icon: <MdRestore className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Schadebestek',
            description: 'Gedetailleerde schadebeoordeling en opmaak van een hersteldossier na een ongeval of schade aan je voertuig.',
            icon: <TbReportSearch className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Airco',
            description: 'Onderhoud en reparatie van aircosystemen voor een koel en comfortabel rijklimaat, zelfs op de heetste dagen.',
            icon: <PiThermometerColdLight className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Vervangwagen',
            description: 'Tijdelijk een vervangwagen voor wanneer je voertuig in onderhoud is, zodat je altijd mobiel blijft.',
            icon: <LiaCarSolid className="w-12 h-12 text-[#3686c4]" />,
        }
    ];

    return (
        <div>
            <section className="section services-section">
                <ContentWrapper>
                    <div className="services-intro">
                        <div className="services-intro-content">
                            <div className="services-text-block">
                                <h2 className="title services-title">Onze diensten</h2>
                                <p className="services-text">
                                    Bij Auto-Service Thomas kunt u rekenen op een compleet aanbod aan diensten voor uw wagen.
                                    Van onderhoud en herstellingen tot diagnose, bandenservice en airco-onderhoud – wij zorgen ervoor dat uw voertuig in topconditie blijft.
                                    Daarnaast staan we ook klaar voor keuring nazicht, carrosseriewerken en oldtimerrestauratie. Hieronder vindt u een overzicht van al onze diensten.
                                </p>
                                <p className="services-text">Staat de gewenste dienst er niet bij? Neem contact met ons op voor een oplossing op maat — we denken graag met u mee.</p>
                            </div>
                            <div className="services-logo-block">
                                <img src={AutoFirst} alt="AutoFirst logo" className="services-logo" />
                            </div>
                        </div>
                    </div>

                    <div className="services-grid our-services-grid">
                        {services.map((service, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">{service.icon}</div>
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                            </div>
                        ))}
                    </div>
                </ContentWrapper>
            </section>
        </div>
    );
}

export default ServicesPage;